/**
 * @file 滾動至頂部 Hook
 * @description 提供路由變化時自動滾動至頁面頂部的 Hook
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 自定義 Hook：監聽路由變化並將視窗回歸頂部
 * 當路由路徑發生變化時，自動將頁面滾動到頂部
 */
const useScrollToTop = (): void => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);
};

export default useScrollToTop;
